import { LocationDescription } from '../../../infrastructure/utils/common';

export const TRAVEL = 'Travel & Stay';
export const FLIGHT_TRAVEL = 'Flight';
export const LODGING_TRAVEL = 'Lodging';
export const GROUND_TRAVEL = 'Ground Transportation';
export const BUS_TRAVEL = 'Limo / Party Bus';

export class Passengers {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  locationFrom = new LocationDescription();
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  locationTo = new LocationDescription();
  members = [];
  flightNumber = null;
}

export class Event {
  eventTitle = '';
  eventType = '';
  eventCategory = '';
  eventName = '';
  autojoin = true;
  eventDescription = null;
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  eventLocation = new LocationDescription();
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  eventLocationFrom = new LocationDescription();
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  eventLocationTo = new LocationDescription();
  eventDate = undefined;
  passengers = undefined;
  startTime = -1;
  endTime = -1;
  cost = '0';
  costType = null;
  dressCode = '';
  isSecret = false;
  timeTBD = false;
  dateTBD = false;
  defaultImageId = '';
  checkoutDate = undefined;
  image = null;
  attendees = [];
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export class EventCategory {
  constructor({ Name, NameLabel, Types, Labels }) {
    this.Name = Name;
    this.NameLabel = NameLabel;
    this.Types = Types;
    this.Labels = Labels;
  }
  Name = '';
  NameLabel = '';
  Types = [];
  Labels = [];
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export class TravelDetail {
  constructor({
    Title,
    NameLabel,
    FromLabel,
    FromDateLabel,
    FromTimeLabel,
    ToLabel,
    ToDateLabel,
    ToTimeLabel,
  }) {
    this.Title = Title;
    this.NameLabel = NameLabel;
    this.FromLabel = FromLabel;
    this.FromDateLabel = FromDateLabel;
    this.FromTimeLabel = FromTimeLabel;
    this.ToLabel = ToLabel;
    this.ToDateLabel = ToDateLabel;
    this.ToTimeLabel = ToTimeLabel;
  }
  Title = '';
  NameLabel = '';
  FromLabel = '';
  FromDateLabel = '';
  FromTimeLabel = '';
  ToLabel = '';
  ToDateLabel = '';
  ToTimeLabel = '';
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export const activityCategories = [
  'Ways to Drink',
  'Places to Eat',
  'Things to Do',
  'Travel Info',
];

export const newCategories = ['Event', 'Ground Transportation'];

export const travelLabels = [
  {
    Name: 'Flight',
    From: 'From Where',
    To: 'To Where',
    Start: 'When does your flight take off?',
    End: 'When does your flight land?',
  },
  {
    Name: 'Train',
    From: 'From Where',
    Start: 'When does your train depart?',
    End: 'When does your train arrive?',
  },
  {
    Name: 'Drive',
    From: 'From Where',
    Start: 'When will you start the drive?',
    End: 'When will you complete the drive?',
  },
  {
    Name: 'Other',
    From: 'From Where',
    Start: 'When will you start your travel?',
    End: 'When will you complete your travel?',
  },
];

export const categories = [
  new EventCategory({
    Name: 'Things to Do',
    NameLabel: 'Event Name',
    Types: [
      'Tourism, Sightseeing',
      'Live Events & Shows',
      'Outdoor Activities',
      'Spas, Health, Wellness',
      'Adult Entertainment',
      'Other',
    ],
    Labels: [],
  }),
  new EventCategory({
    Name: 'Travel & Stay',
    NameLabel: 'Flight',
    Types: ['Flight', 'Lodging', 'Ground Transportation', 'Limo / Party Bus'],
    Labels: [
      new TravelDetail({
        Title: 'Flight',
        NameLabel: 'Airline and Flight Number',
        FromLabel: 'From',
        FromDateLabel: 'Departure Date',
        FromTimeLabel: 'Departure Time',
        ToLabel: 'To',
        ToDateLabel: 'Arrival Date',
        ToTimeLabel: 'Arrival Time',
      }),
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      new TravelDetail({
        Title: 'Lodging',
        FromLabel: 'Location',
        FromDateLabel: 'Check-in Date',
        FromTimeLabel: 'Check-in Time',
        ToDateLabel: 'Check-out Date',
        ToTimeLabel: 'Check-out Time',
      }),
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      new TravelDetail({
        Title: 'Ground Transportation',
        NameLabel: 'Service Provider Name',
        FromLabel: 'Pickup Location',
        FromDateLabel: 'Pickup Date',
        FromTimeLabel: 'Pickup Time',
        ToLabel: 'Dropoff Location',
      }),
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      new TravelDetail({
        Title: 'Limo / Party Bus',
        NameLabel: 'Service Provider Name',
        FromLabel: 'Pickup Location',
        FromDateLabel: 'Pickup Date',
        FromTimeLabel: 'Pickup Time',
        ToLabel: 'Dropoff Location',
      }),
    ],
  }),
];
